export default {
  edgeRow1: '工业4.0要求数百万个传感器和IIoT设备生成的数据能够进行实时处理，意味着数据处理活动与操作必须移近源头，这也是构建杰为平台的前情。杰为数字化链确保进行精确处理所需的智能可以应用于中央云存储库中，由整条价值链共享，设备应用在云上创建配置后，能够自动加载到边缘而无需停机。'
}
